import { render, staticRenderFns } from "./CreateChatDialog.vue?vue&type=template&id=86636b26&scoped=true"
import script from "./CreateChatDialog.vue?vue&type=script&lang=js"
export * from "./CreateChatDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateChatDialog.vue?vue&type=style&index=0&id=86636b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86636b26",
  null
  
)

export default component.exports